"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _commonConstants = require("../../../utils/common-constants");

var _constants = require("./constants");

var _utils = require("../../profile-policy/utils");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  error: null,
  data: []
};

var resourceLabels = function resourceLabels() {
  var _action$payload, _action$payload2;

  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.ResourceLabelsType.RESOURCE_LABELS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING,
        data: []
      });

    case _constants.ResourceLabelsType.RESOURCE_LABELS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: !(0, _utils.isResourcePolicyPath)() ? Object.entries(((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.associations) || {}).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              values = _ref2[1];

          return {
            key: key,
            values: values
          };
        }) : ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.data) || []
      });

    case _constants.ResourceLabelsType.RESOURCE_LABELS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload,
        data: []
      });

    default:
      return state;
  }
};

var resourceLabelsReducer = (0, _redux.combineReducers)({
  resourceLabels: resourceLabels
});
var _default = resourceLabelsReducer;
exports.default = _default;